import type { Location } from 'history'
import { RouterStore } from 'mobx-react-router'
import qs from 'qs'
import { RouteName } from 'src/router/RouteName'

import { UrlListener } from './UrlListener'

export interface LocationInfo extends Location<unknown> {
  searchData: Record<any, any>
  fullPath: string
}

export class CustomRouterStore extends RouterStore {
  constructor() {
    super()
    this.lastLocationMap.set(RouteName.home, RouteName.dashboard)

    this.lastLocationMap.set(RouteName.lessonPreparation, RouteName.academyShareScopeWorksheet)
    this.lastLocationMap.set(RouteName.academy, RouteName.studentManage)
    this.lastLocationMap.set(RouteName.myInfo, RouteName.myUserInfo)

    // 수업준비 디폴트 경로
    // workbook은 권한별 분기(시그니처/학원그룹/academy)가 있어 LessonPreparePage의 WORKBOOK_PATH_REDIRECT_URL에 위임 — 정적 default 미설정
    this.lastLocationMap.set(RouteName.worksheet, RouteName.academyShareScopeWorksheet)
    this.lastLocationMap.set(RouteName.theme, RouteName.textbookWorksheet)

    // 기관 디폴트 경로
    this.lastLocationMap.set(RouteName.academyManage, RouteName.studentManage)
    this.lastLocationMap.set(RouteName.smsManage, RouteName.smsSend)
    this.lastLocationMap.set(RouteName.customer, RouteName.customerNotice)
    this.lastLocationMap.set(RouteName.attendance, RouteName.attendanceManage)
    this.lastLocationMap.set(RouteName.vodColumn, RouteName.vodColumnList)
  }

  getParams<T extends Record<any, any> = {}>(): T {
    return qs.parse(this.location.search.replace('?', ''), { comma: true }) as T
  }
  addParams(param: Record<any, any>) {
    const params = qs.parse(this.location.search, { ignoreQueryPrefix: true })
    return qs.stringify({ ...params, ...param })
  }
  setParams(params: Record<any, any>, trigger = false) {
    this.replace({ search: qs.stringify(params, { arrayFormat: 'comma' }) })
    if (trigger) this.listener.triggerAllProcess(this.history.location)
  }

  getLocationInfo(): LocationInfo {
    const fullPath = this.location.pathname + this.location.search + this.location.hash
    return {
      ...this.location,
      searchData: this.getParams(),
      fullPath,
    }
  }

  static isSameLocationUrl(location1: Location<any>, location2: Location<any>) {
    if (location1.pathname !== location2.pathname) return false
    if (location1.search !== location2.search) return false
    if (location1.hash !== location2.hash) return false

    return true
  }

  listener = new UrlListener(this)

  lastLocationMap = new Map<string, string>()

  getLastLocation(to: string) {
    const [, header, subHeader, tabHeader] = to.split('/')
    // 1. 헤더 간 전환
    if (!subHeader) return this.lastLocationMap.get(`/${header}`)
    // 2. 서브헤더 간 전환
    if (!tabHeader) return this.lastLocationMap.get(`/${header}/${subHeader}`)
    // 3. 탭 간 전환
    return to
  }
}
